import { DateTime } from "luxon";
import React from "react";
import { RangeColumnDefinition, RangeCriteria, RangeFilterChangeFunction, rangeFilter } from "./RangeColumnDefinition";
import { DateRangeFilter } from "../../../filters/DateTimeRangeFilter";
import { datetimeComparator } from "@goodfill/sort";
import { TIMEZONE_NEY_YORK } from "../../../locale/timezone";

export const dateRangeFilter = <TCriteriaKey extends string, TItemKey extends string>(
  criteriaKey: TCriteriaKey,
  itemKey: TItemKey,
  zone: string,
) => rangeFilter(criteriaKey, itemKey, datetimeComparator);

export const DateRangeColumnDefinition = <TCriteriaKey extends string, TItemKey extends string>(
  name: React.ReactNode,
  itemKey: TItemKey,
  criteriaKey: TCriteriaKey,
  criteria: RangeCriteria<TCriteriaKey, DateTime>,
  onFilterChange: RangeFilterChangeFunction<TCriteriaKey, DateTime>,
  itemRenderer: (item: { [key in TItemKey]: DateTime }) => React.ReactNode,
) =>
  RangeColumnDefinition(
    name,
    itemKey,
    criteriaKey,
    criteria,
    onFilterChange,
    () => (
      <DateRangeFilter
        timezone={TIMEZONE_NEY_YORK}
        small
        value={criteria[criteriaKey]}
        onChange={(value) => onFilterChange(criteriaKey, value)}
      />
    ),
    itemRenderer,
  );
